<template>
  <div class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="headerName"></ContentHeader>
        <section v-if="activeNominationEvent.length > 0">
          <div v-for="award in activeNominationEvent" v-bind:key="award.id">
            <div class="card mb-3">
              <div v-if="award._embedded['wp:featuredmedia']" class="featuredImg">
                <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                  :title="award._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
              <div v-if="award.nomination_event_time_frame.length > 0">
                <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                  <li class="h6">
                    <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
              <div class="card-body" v-html="award.additional_content[0]"></div>
            </div>
          </div>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ChildNominationEventsList from '@/components/ChildNominationEventsList'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    ChildNominationEventsList
  },
  data () {
    return {
      activeNominationEvent: [],
      inactiveNominationEvent: [],
      errors: [],
      contentReady: false,
      contentLoadError: '',
      noExpire: false,
      headerName: ''
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserCommunityIDstring'
    ])
  },
  created () {
    this.loadContent()
  },
  methods: {
    getAPiCallString: function () {
      if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
        return 'community_categories=' + this.getUserCommunityIDstring
      } else {
        return ''
      }
    },
    loadContent: function () {
      document.title = this.$route.name + ' - ThinkTank'
      // Innovation Awards categoyr ID 105
      WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=105&_embed')
        .then(response => {
          this.headerName = response.data[0].title.rendered
          this.activeNominationEvent = response.data.filter(x => !x.nomination_event_category.includes(35))
          this.inactiveNominationEvent = response.data.filter(x => x.nomination_event_category.includes(35))
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading the Recognitions. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    '$route' (to, from) {
      this.loadContent()
    },
    getUserCommunityIDstring (newDetails, oldDetails) {
      if (!this.$store.getters.isAdmin) {
        this.loadContent()
      }
    }
  }
}
</script>

<style lang="less">
  .featuredImg {
    img {
      width: 100%;
    }
  }
  .box {.icon { text-align: center; position: relative; }}
  .box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
  .box { .icon:hover { .image { background: #63B76C; }}}
  .box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
  .box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
  .box { .icon { .infoaqua { background-color:#CEF6F8; }}}
  .box { .icon { .infogrey { background-color:#F8F8F8; }}}
  .box { .icon { .infowhite { background-color:#FFFFFF; }}}
  .box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
  .box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
  .box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
  .box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
  .box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
  .box { .icon { .info { p {margin-left: 40px;}}}}
  .aquacolor {color:#09ced6;}
  .navycolor {color: navy;}  
</style>



// WEBPACK FOOTER //
// src/components/routes/InnovationAward.vue